import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import moment from 'moment';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const Header = ({ item, ...rest }) => {
  return (
    <div {...rest}>
      <Box mb={2}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link
            variant="body1"
            color="inherit"
            to="/trainer/nutrition"
            component={RouterLink}
          >
            Back to Nutrition
          </Link>
        </Breadcrumbs>
      </Box>

      <Typography variant="h3" color="textPrimary">
        {item.title}
      </Typography>
      <Typography variant="caption">
        Last Saved: {moment(item.updatedAt).format('LLL')}
      </Typography>
    </div>
  );
};

export default Header;
